/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2018, Zumper
 * @description  Action creators for the location module
 */

import { createAction } from 'redux-actions'
import {
  CLEAR_DESTINATION_NAME,
  COUNTRY_CODE_CHANGED,
  DESTINATION_NAME_CHANGED,
  DONE_LOADING,
  MISSING_LOCATION,
  NOT_MISSING_LOCATION,
  START_LOADING,
} from './constants'

export {
  boxChanged,
  centerChanged,
  zoomChanged,
  cityNameChanged,
  clearCityName,
  hoodNameChanged,
  clearHoodName,
  stateNameChanged,
  clearStateName,
  urlChanged,
} from '@zcode-ui/map'

export const destinationNameChanged = createAction<string, typeof DESTINATION_NAME_CHANGED>(
  DESTINATION_NAME_CHANGED
)
export const clearDestinationName = createAction(CLEAR_DESTINATION_NAME)

export const missingLocation = createAction(MISSING_LOCATION)
export const notMissingLocation = createAction(NOT_MISSING_LOCATION)

export const startLoading = createAction(START_LOADING)
export const doneLoading = createAction(DONE_LOADING)
export const countryCodeChanged = createAction<string, typeof COUNTRY_CODE_CHANGED>(
  COUNTRY_CODE_CHANGED
)
